<template>
  <header id="header" class="clearfix static-sticky">
    <div id="header-wrap">
      <div class="container clearfix">
        <div id="primary-menu-trigger">
          <i class="icon-reorder"></i>
        </div>

        <div id="logo">
          <router-link to="/" class="standard-logo">
            <img src="images/logo-n.png" alt="BG Logo" />
            <img src="images/logo.png" alt="BG Logo" />
          </router-link>
          <router-link to="/" class="retina-logo">
            <img src="images/logo-n.png" alt="BG Logo" />
            <img src="images/logo.png" alt="BG Logo" />
          </router-link>
        </div>

        <nav
          id="primary-menu"
          class="d-lg-flex d-xl-flex justify-content-xl-between justify-content-lg-between fnone with-arrows"
        >
          <ul class="align-self-start">
            <li>
              <span class="menu-bg col-auto align-self-start d-flex"></span>
            </li>
            <li :class="$router.currentRoute.path == '/' ? 'active' : ''">
              <router-link to="/">
                <div>Ana Sayfa</div>
              </router-link>
            </li>
            <li
              :class="
                $router.currentRoute.path == '/misyonumuz' ||
                $router.currentRoute.path == '/vizyonumuz' ||
                $router.currentRoute.path == '/tarihce' ||
                $router.currentRoute.path == '/weps' ||
                $router.currentRoute.path == '/uyeler' ||
                $router.currentRoute.path == '/neler-yaptik'
                  ? 'active'
                  : ''
              "
            >
              <a href="javascript: void(0)">
                <div>Hakkımızda</div>
              </a>
              <ul>
                <li>
                  <router-link to="/misyonumuz">
                    <div>Misyonumuz</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/vizyonumuz">
                    <div>Vizyonumuz</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/tarihce">
                    <div>Tarihçe</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/weps">
                    <div>Kadının Güçlenmesi Prensipleri (WEPs)</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/uyeler">
                    <div>Destekçilerimiz</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/neler-yaptik">
                    <div>Neler Yaptık?</div>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              :class="$router.currentRoute.path == '/strateji' ? 'active' : ''"
            >
              <router-link to="/strateji">
                <div>Strateji</div>
              </router-link>
            </li>
            <li
              :class="
                $router.currentRoute.path == '/iyi-uygulamalar' ? 'active' : ''
              "
            >
              <router-link to="/iyi-uygulamalar">
                <div>İyi Uygulamalar</div>
              </router-link>
            </li>
            <li
              :class="
                $router.currentRoute.path == '/arastirmalar' ? 'active' : ''
              "
            >
              <router-link to="/arastirmalar">
                <div>Araştırmalar</div>
              </router-link>
            </li>
          </ul>
          <ul class="not-dark align-self-end">
            <li>
              <a
                href="https://ast.birliktegucluyuz.org/"
                target="_blank"
                class="btn-default"
              >
                <div style="color: #e5301d">Giriş Yap</div>
              </a>
            </li>
            <li>
              <a
                href="https://social.birliktegucluyuz.org/"
                target="_blank"
                class="header-button"
              >
                <div style="color: #fff">BG Social</div>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  mounted() {
    this.$router.afterEach((to, from) => {
      this.$forceUpdate();
    });
  }
};
</script>

<style>
.standard-logo img:first-child {
  display: none !important;
}
.retina-logo img:first-child {
  display: none !important;
}
@media (max-width: 991px) {
  .retina-logo img:first-child {
    display: block !important;
  }
  .standard-logo img:first-child {
    display: block !important;
  }
  .retina-logo img:nth-child(2) {
    display: none !important;
  }
  .standard-logo img:nth-child(2) {
    display: none !important;
  }
}
</style>
